<template>
  <div class="pagetitle-container">
    <h1>
      <slot></slot>
    </h1>
  </div>
</template>

<script>
  export default {
    name: "pageTitle"
  }
</script>

<style scoped lang="scss">
  .pagetitle-container {
    margin-bottom: 20px;

    h1 {
      text-align: center;
      padding-bottom: 10px !important;
      padding-top: 15px !important;
      border-bottom: 3px solid #b1b1b1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pageTitle.vue